import { DelegationCard } from './DelegationCard';
import type { DelegationCard as DelegationCardType } from '../types';

interface DelegationCardListProps {
  cards: DelegationCardType[];
  selectedCardId?: string;
  votedCardId?: string;
  disabled?: boolean;
  onCardClick?: (cardId: string) => void;
}

export const DelegationCardList = ({
  cards,
  selectedCardId,
  votedCardId,
  disabled = false,
  onCardClick,
}: DelegationCardListProps) => {
  return (
    <div className="w-full">
      <div className="grid grid-cols-3 gap-3 sm:grid-cols-4 md:grid-cols-4">
        {cards.map((card) => (
          <DelegationCard
            key={card.id}
            id={card.id}
            name={card.name}
            description={card.description}
            isSelected={selectedCardId === card.id}
            isVoted={votedCardId === card.id}
            disabled={disabled}
            onClick={() => onCardClick?.(card.id)}
          />
        ))}
      </div>
    </div>
  );
};
